import React from "react";

import {Redirect, Route, Switch} from "react-router-dom";

// General:
import Login from "../auth/Login/Login";
import {Alert, ReduxProtectedRoute} from "@leap4/frontend";
import {urlService} from "./urlsService";


//  Modules:

import {BACKEND_SERVICE_NAME, requiredAuthRoles} from "../../config/generals";
import SiteManager from "../modules/sites/siteManager";
import SellersManager from "../modules/sellers/sellersManager";
import {ManageUser} from "../modules/users/user/manageUser";
import UserDashboard from "../modules/users/users/userDashboard";
import DemandDashbord from "../modules/demands/demands/demandDashbord";
import {ManageDemand} from "../modules/demands/demand/manageDemand";
import WLGeneratorManager from "../modules/demandWLGenerator/wLGeneratorManager";
import AppsDataManager from "../modules/appsData/appsDataManager";
import Integrations from "../modules/integrations/integrations";
import { ManageIntegration } from "../modules/integrations/integration/manageIntegration";
import AppAdsLinesManager from "../modules/appAdsLines/appAdsLinesManager";
import { ManageTrackedPublisher } from "../modules/appAdsLines/manageTrackedPublisher";
import TrackedPublisherDetail from "../modules/appAdsLines/trackedPublisherDetail";




const Routes = () => {

    return (
        <section className="container">
            <Alert/>
            <Switch>
                <Route exact path="/login" component={Login}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={SiteManager} path={urlService.sites()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={SellersManager} path={urlService.sellers()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={ManageUser} path={urlService.addUser()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={ManageUser} path={urlService.editUser()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={UserDashboard} path={urlService.users()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={ManageDemand} path={urlService.addDemand()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={ManageDemand} path={urlService.editDemand()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={DemandDashbord} path={urlService.demands()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={WLGeneratorManager} path={urlService.demandWLGenerator()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={AppsDataManager} path={urlService.appsData()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={Integrations} path={urlService.integrations()}
                />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={ManageIntegration} path={urlService.newIntegration()}
                />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={ManageIntegration} path={urlService.editIntegration()}
                />

                {/* The standalone Lines Generator is gone - Publisher Lines generates the same
                    lines and tracks them. Redirect rather than delete the path, so existing
                    bookmarks don't fall through to the login screen. */}
                <Redirect exact from={urlService.appAds()} to={urlService.appAdsLines()}/>

                {/* Publisher Lines. Static segments (/add, /all) are declared before the
                    `:id` route so they aren't read as ids, matching how the demand
                    routes are ordered. The /edit route is likewise declared before the bare
                    publisher route. */}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={ManageTrackedPublisher} path={urlService.addTrackedPublisher()}/>
                {/* Both list routes render the same shell; it picks the tab from the path, so
                    /app-ads-lines/all stays a shareable link. */}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={AppAdsLinesManager} path={urlService.appAdsLinesAll()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={ManageTrackedPublisher} path={urlService.editTrackedPublisher()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={TrackedPublisherDetail} path={urlService.trackedPublisher()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                        requiredRoles={requiredAuthRoles}
                                        component={AppAdsLinesManager} path={urlService.appAdsLines()}/>
                <Route component={Login}/>
            </Switch>
        </section>
    )
};

export default Routes;
